import { toZonedTime, formatInTimeZone } from "date-fns-tz";

export const formatarDataBrasilia = (data) => {
  const timeZone = "America/Sao_Paulo"; // Fuso horário de Brasília
  const zonedDate = toZonedTime(data, timeZone);
  return formatInTimeZone(zonedDate, timeZone, "dd/MM/yyyy");
};

export const formatarDataHoraBrasilia = (data) => {
  const timeZone = "America/Sao_Paulo"; // Fuso horário de Brasília
  const zonedDate = toZonedTime(data, timeZone);
  return formatInTimeZone(zonedDate, timeZone, "dd/MM/yyyy - HH:mm:ss");
};

export const formatarHoraBrasilia = (data) => {
  const timeZone = "America/Sao_Paulo"; // Fuso horário de Brasília
  const zonedDate = toZonedTime(data, timeZone);
  return formatInTimeZone(zonedDate, timeZone, "HH:mm");
};
